import DialogComponent from '../DialogComponent/DialogComponent'
import * as React from 'react'
import { IQuiz } from '../../interfaces/IQuiz'
import { ICourseTopic } from '../../interfaces/ICourse'
import useUserAuthStatus from '../Auhentication/useUserAuthStatus'
import { Button, Container } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import {
  getURLQueryParameter,
  removeURLQueryParameter,
  setURLQueryParameter,
} from '../../services/config'
import StudentCourseAssessment from '../Classroom/ClassroomLearnersComponents/StudentCourseAssessment'

const UrlKey = 'quizId'

export default function SchoolHomepageQuizListDialogButtonComponent(props: {
  quiz: IQuiz
  topic: ICourseTopic
  handleOpenAuthDialog: () => void
  openAuthDialog: boolean
}) {
  const [openDialog, setOpenDialog] = React.useState(isQuizSelected())

  const theme = useTheme()
  const userAuthStatus = useUserAuthStatus()

  function isQuizSelected() {
    const selectedQuizId = getURLQueryParameter(UrlKey)
    if (!selectedQuizId) {
      return false
    }

    return [props.quiz?.slug, props.quiz?._id].includes(selectedQuizId)
  }

  const openDialogStateChange = () => {
    setOpenDialog(true)
    setURLQueryParameter(
      UrlKey,
      props.quiz?.slug || (props.quiz?._id as string),
    )
  }

  const closeDialogStateChange = () => {
    setOpenDialog(false)
    removeURLQueryParameter(UrlKey)
  }

  return (
    <div>
      <div>
        {userAuthStatus.isLoggedIn ? (
          <Button
            variant={'contained'}
            color={'primary'}
            onClick={openDialogStateChange}
          >
            Open quiz
          </Button>
        ) : (
          <Button
            style={{
              width: '140px',
              height: '35px',
              background: theme.palette.primary.main,
              borderRadius: '9px',
              color: 'white',
              outline: 0,
              border: 0,
            }}
            onClick={props.handleOpenAuthDialog}
          >
            Login/Register
          </Button>
        )}
      </div>
      <DialogComponent
        contentPadding="0px"
        title={props.quiz?.name}
        fullScreen={false}
        disableBackgroundClickClose={true}
        onRequestClose={closeDialogStateChange}
        open={openDialog}
        contentStyle={{ backgroundColor: '#fff', minWidth: '300px' }}
        content={
          <div>
            {userAuthStatus.userDetails && (
              <Container maxWidth={'sm'}>
                <StudentCourseAssessment
                  user_details={userAuthStatus.userDetails}
                  user_type={userAuthStatus.userDetails?.user_type}
                  topic={props.topic}
                />
              </Container>
            )}
          </div>
        }
      />
    </div>
  )
}
